import React from 'react'
import { toast } from "react-toastify";
import { EditOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Link, useParams } from "react-router-dom";


import ComplianceBasicDetail from "./ComplianceController/ComplianceBasicDetail";

import EnableDisableButton from "components/Shared/EnableDisableButton";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import {
  useGetComplianceDetailQuery,
  useUpdateComplianceMutation
} from "store/services/complianceApi";

import { ComplianceDetailContext, useComplianceDetailContext } from "contexts/ComplianceDetailContext";



const ComplianceDetailScreen = () => {
  const { id } = useParams();

  const breadcrumb = [
    { title: "Compliance", path: "/app/crm/compliance/list" },
    { title: "Compliance Detail" }
  ]

  // RTK Query
  const {
    data: complianceDetail,
    isLoading: loadingCompliance,
    error,
  } = useGetComplianceDetailQuery(id);

  return (
    <ComplianceDetailContext.Provider value={{ complianceDetail, loadingCompliance }}>
      <BreadcrumbLayout breadcrumbs={breadcrumb}
        isBusy={loadingCompliance}
        headerActions={<PageActions />} >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <ComplianceBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </ComplianceDetailContext.Provider>
  );
}

export default ComplianceDetailScreen;

const PageActions = () => {
  const { complianceDetail, loadingCompliance }
    = useComplianceDetailContext();

  // RTK Query
  const [updateCompliance, { isLoading: updatingCompliance }]
    = useUpdateComplianceMutation();

  // methods
  const handelToggleComplianceStatus = async () => {
    try {
      await updateCompliance({
        _id: complianceDetail._id,
        isActive: !complianceDetail.isActive,
      }).unwrap();
      toast.info(`Compliance ${complianceDetail.isActive ? "Disable" : "Enable"} !`);
    } catch (error) {
      toast.error(error?.data.message ?? "Could Not Update Status");
    }
  }

  return (
    <div className="flex space-x-4">
      <EnableDisableButton
        isActive={complianceDetail?.isActive}
        loading={loadingCompliance || updatingCompliance}
        onClick={handelToggleComplianceStatus}
      />
      <Link to={`/app/crm/compliance/${complianceDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};